module.exports = __webpack_public_path__ + "img/AZ.91befeeb.svg";